"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../styles/styles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const providerCardStyles_1 = __importDefault(require("./providerCardStyles"));
const ProviderCard = ({ logo, onPress, isConnected, eventName }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [
            providerCardStyles_1.default.cardBackground,
            {
                borderColor: isConnected ? theme_1.default.colors.COLOR_PRIMARY : theme_1.default.colors.COLOR_GRAY,
            },
        ] },
        react_1.default.createElement(touchableElement_1.default, { onPress: onPress, eventName: eventName, style: [{ minHeight: 70, maxHeight: 70 }, styles_1.default.centerChildHorizontalVertical] }, logo)));
};
exports.default = ProviderCard;
